export default {
    BETTING_NOW: "/api/v1.0.0/betting/lotto90",
    FETCH_LOTTO90_RESULT_REPORT: "/api/v1.0.0/drawing/lotto90-lists",
    FETCH_LOTTO90_DRAWING_RESULT: "/api/v1.0.0/drawing/lotto90",
    FETCH_LOTTO90_WIN_LOSS_REPORT: "/api/v1.0.0/reports/lotto90-win-lose",
    FETCH_LOTTO90_RECENT_TICKET: "/api/v1.0.0/reports/recent-betting",
};
